/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import { CommonContractorCreateUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import ContractorCompanyFields from "./ContractorCompanyFields";
import ManagerFields from "./ManagerFields";
import { EmployeeFlowContractorCreateApp } from "../../Functionality/ContractorCreateUpdateFlows/EmployeeFlowContractorCreateApp";
import StepTab from '../../../../../components/StepperTabs/StepTab';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import {
    SUGGESTION_MODE_OPTION
} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import Summary from './Summary';
import AccessRights from '../../../Company/Employees/AccessRightsSection/AccessRights';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import {STEPS_CONTRACTOR_CREATE, TABS_CONTRACTORS} from '../../Model/Models';

const EmployeeFlowContractorCreate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        isValidEmail,
        isValidPassword, 
        setIsValidPassword,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        setIsValidEmail,
        setIsValidPhoneNumber,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,

        photoPicker,
        setPhotoPicker
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack
    } = EmployeeFlowContractorCreateApp({
        t,
        dispatch,
        navigate,
        workShiftsList,
        customizedList,
        setEmptyFields,
        setIsValidEmail,
        isValidPassword,
        setIsValidPassword,
        setIsValidPhoneNumber,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        permission,
        setWorkShiftsList,
        setCustomizedList,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        setSteps
    });


    if (!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) ||
        !permission?.includes(permissionObj.WEB_CONTRACTOR_CREATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name={t("create")}
            />


            <StepperTabs id={null} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={() => { }}
                setActiveStep={setActiveStep} handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CONTRACTOR_CREATE.COMPANY_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_CREATE.COMPANY_DETAILS &&
                        <>
                            <ContractorCompanyFields
                                user={user}
                                setUser={setUser}
                                emptyFields={emptyFields}
                                resetForm={()=>{
                                    resetForm(activeStep);
                                }}
                                getAllServiceType={getAllServiceType}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px'>
                                <ButtonNextStep
                                    id='btn_efcc_next_company_fields'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS &&
                        <>
                            <ManagerFields
                                title={"manager"}
                                user={user}
                                setUser={setUser}
                                emptyFields={emptyFields}
                                isValidDocumentId={isValidDocumentId}
                                setIsValidDocumentId={setIsValidDocumentId}
                                isValidEmail={isValidEmail}
                                isValidPhoneNumber={isValidPhoneNumber}
                                isValidDob={isValidDob}
                                setIsValidDob={setIsValidDob}
                                handleEmailChange={handleEmailChange}
                                handlePasswordChange={handlePasswordChange}
                                handlePhoneNumberChange={handlePhoneNumberChange}
                                handleDateChange={handleDateChange}
                                statusList={userInfoStatusList}
                                handleClearAll={()=>{
                                    resetForm(STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS);
                                }}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                                <ButtonPrevStep
                                    id='btn_efcc_back_manage_fields'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_efcc_next_manage_fields'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_CREATE.ADD_PHOTO} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_CREATE.ADD_PHOTO &&
                        <>
                            <CustomPhotoPicker
                                id='fp_ce_create_photo_profile'
                                photoPicker={photoPicker}
                                setPhotoPicker={setPhotoPicker}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                showBtnCamera={true}
                                validateFace={true}
                                classWith={'content-center-w-400px mt-4'}
                                showPreview={true}
                                disabled={disabled}
                                typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                            />
                            <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                                <ButtonPrevStep
                                    id='btn_efcc_back_photo_picker'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_efcc_next_photo_picker'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }}
                                />
                            </div>
                        </>
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_CREATE.ACCESS_RIGHT} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_CREATE.ACCESS_RIGHT &&
                        <>
                            <AccessRights
                                workShiftsList={workShiftsList}
                                setWorkShiftsList={setWorkShiftsList}
                                customizedList={customizedList}
                                setCustomizedList={setCustomizedList}
                                user={user}
                                isEditable={true}
                                resetForm={()=>{
                                    resetForm(activeStep);
                                }}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                                <ButtonPrevStep
                                    id='btn_efcc_back_access_rights'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_efcc_next_access_rights'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }}
                                />
                            </div>
                        </>
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_CREATE.SUMMARY} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_CREATE.SUMMARY &&
                        <>
                            <Summary
                                user={user}
                                workShiftsList={workShiftsList}
                                customizedList={customizedList}
                                photoPicker={photoPicker}
                                getAllServiceType={getAllServiceType}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                                <ButtonPrevStep
                                    id='btn_efcc_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_efcc_enroll_contractor'
                                    text='create'
                                    click={() => {
                                        validateEmail(user.email);
                                        validatePhone(user.phoneNumber);
                                        FormHandler();
                                    }}
                                />
                            </div>
                        </>
                    }
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.contractor.list, {
                        state: {currentTab:TABS_CONTRACTORS.CONTRACTORS.INDEX}
                    });
                }}
                closeText={'continue'}
            />

        </>
    );
};

export default EmployeeFlowContractorCreate;
